import { useCallback, useRef } from 'react';

/**
 * Reiht asynchrone Aktionen hintereinander ein, statt sie parallel laufen zu
 * lassen (B5).
 *
 * Hintergrund: Mehrere Checklisten-Haken kurz nacheinander erzeugten
 * gleichzeitige PATCHes. Deren onSettled-Invalidierungen ueberholten sich
 * gegenseitig, sodass die Antwort eines frueheren Requests den spaeteren
 * Stand ueberschrieb und ein Haken wieder heraussprang.
 *
 * Die Kette bricht bewusst nicht ab, wenn ein Glied scheitert — ein
 * fehlgeschlagener Request darf die folgenden nicht blockieren. Der Fehler
 * selbst wird von der jeweiligen Mutation behandelt.
 */
export function useSerielleAktion() {
  const kette = useRef<Promise<unknown>>(Promise.resolve());

  return useCallback((aktion: () => Promise<unknown>): Promise<unknown> => {
    const naechste = kette.current.then(aktion, aktion);
    // Fehler hier abfangen, damit die Kette nicht als unhandled rejection endet.
    kette.current = naechste.catch(() => undefined);
    return naechste;
  }, []);
}
